import axios, {AxiosInstance} from 'axios';
import StorageHelper from "./StorageHelper";
import Storage from "./StorageHelper";

abstract class HttpClient {
    protected endpoint: string;
    protected client: AxiosInstance;
    private interceptorId: number | undefined;

    protected constructor(endpoint: string) {
        this.endpoint = endpoint;
        this.client = axios.create({
            baseURL: `${endpoint}/prod`, responseType: 'json'
        });
        this.setupInterceptor();
    }

    protected async refreshToken() {
        try {
            return await this.client.post('/token/refresh', {
                token: StorageHelper.getRefreshToken()
            })
        } catch (e) {
            console.error("Can't get token")
            throw (e);
        }
    }

    setupInterceptor() {
        this.interceptorId = this.client.interceptors.response.use((response) => {
            return response;
        }, async (error) => {
            console.log(error)
            if (error.response.status === 401 && error.response.data.message === 'The incoming token has expired') {
                console.log("token here")
                // Refresh token and re-send request
                const {data} = await this.refreshToken();
                Storage.update(data.AuthenticationResult.IdToken, data.AuthenticationResult.AccessToken)
                error.config.headers["Authorization"] = `Bearer ${Storage.getIdToken()}`;
                return this.client.request(error.config)
            }
            return Promise.reject(error);
        });
    }
}

export default HttpClient;
